import React, { useEffect, useState } from "react";
import SettingsEmptyState from './SettingsEmptyState';
import {
  ConfirmDelete,
  MwInputText,
  MwSpinner,
  MwSpinnerButton,
} from "../ui";
import { IoMdAdd } from "react-icons/io";

import MwSelectorAccount from "../ui/MwSelectorAccount";
import { useTranslation } from "react-i18next";
import { AiOutlineDelete } from "react-icons/ai";
import { useCurrent, useDelete, useFetch, usePost, usePut } from "../../hooks";
import { NewButton } from "../ui/NewButton";
import { BiSolidMessageSquareEdit } from "react-icons/bi";
import { NewInputLang } from "../ui/NewInputLang";
import { useAccountSettings } from "../../contexts/AccountSettingsContext";

export const Accounts = () => {
  const { t } = useTranslation("settings");
  const { getChartAccountLevelLimit } = useAccountSettings();
  const chartLevelLimit = getChartAccountLevelLimit();
  console.log("Accounts - Chart Level Limit:", chartLevelLimit);
  const [langar, setLangar] = useState(true);
  const [AccountList, setAccountList] = useState([]);
  const [AccountCode, setAccountCode] = useState("");
  const [AccountName, setAccountName] = useState("");
  const [AccountEnName, setAccountEnName] = useState("");
  const [subAccount, setSubAccount] = useState("");
  const [bank_account_no, setbank_account_no] = useState("");
  const [bank_account_iban, setbank_account_ibana] = useState("");
  const [error, setError] = useState({});
  const [onShow, setOnShow] = useState(false);
  const [selectedAccountId, setSelectedAccountId] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [editingAccountId, setEditingAccountId] = useState(null);
  const [treeParent, setTreeParent] = useState([]);
  const [hasFetchedTree, setHasFetchedTree] = useState(false);
  const [accountNamesCache, setAccountNamesCache] = useState({});
  const [isCacheReady, setIsCacheReady] = useState(false);
  const { currentTenantId, currentCompanyId, currentBranchId , currentLangId } = useCurrent();
  const { data, postData, loading } = usePost();
  const { loading: delloading, deleteItem } = useDelete();
  const {
    data: incomesTreasuriesResult,
    loading: loadingTreasuries,
    refreshHandler: refetchTreasuries,
  } = useFetch(
    `${process.env.REACT_APP_FINANCE_API_SERVER_BASE_URL}/banks-accounts/${currentTenantId}/${currentCompanyId}/${currentBranchId}`
  );
  const {
    data: incomesCountResult,
    loading: loadingCountResult,
    refreshHandler,
  } = useFetch(
    `${process.env.REACT_APP_FINANCE_API_SERVER_BASE_URL}/banks-accounts/count/${currentTenantId}/${currentCompanyId}/${currentBranchId}`
  );
  const {
    data: savedata,
    loading: saveloading,
    error: saveerr,
    putData,
  } = usePut();

  useEffect(() => {
    if (incomesCountResult && !isEditing) {
      setAccountCode((parseInt(incomesCountResult?.data) + 1).toString());
    }
  }, [incomesCountResult, isEditing]);

  useEffect(() => {
    if (incomesTreasuriesResult?.data) {
      setAccountList(incomesTreasuriesResult.data);
    }
  }, [incomesTreasuriesResult]);

  // Fetch tree account data (only once)
  useEffect(() => {
    if (currentTenantId && currentCompanyId && !hasFetchedTree) {
      setHasFetchedTree(true);
      postData("https://api.absat-erp.com/acc/tree-account", {
        tenant_id: currentTenantId,
        company_id: currentCompanyId,
      });
    }
  }, [currentTenantId, currentCompanyId, hasFetchedTree]);

  // Update treeParent when data is received and build cache
  useEffect(() => {
    if (data?.data?.treeParent) {
      setTreeParent(data.data.treeParent);
      
      // Build cache for all accounts in the tree
      const buildCache = (tree, cache = {}) => {
        if (!tree || !Array.isArray(tree)) return cache;
        
        tree.forEach(node => {
          cache[node.account_no] = currentLangId === "en" 
            ? (node.name_en || node.name_ar || "")
            : (node.name_ar || node.name_en || "");
          
          if (node.childs && Array.isArray(node.childs)) {
            buildCache(node.childs, cache);
          }
        });
        
        return cache;
      };
      
      const newCache = buildCache(data.data.treeParent);
      setAccountNamesCache(newCache);
      setIsCacheReady(true);
    }
  }, [data, currentLangId]);

  // Get account name from cache
  const getAccountName = (accountNo) => {
    if (!accountNo) return "";
    const extractedNo = typeof accountNo === 'string'
      ? accountNo.split('/').pop()?.trim()
      : accountNo;
    return accountNamesCache[extractedNo] || "";
  };

  // Get extracted account number for display
  const getExtractedAccountNo = (item) => {
    const accountNo = item?.account?.account_no || item?.account_no || "";
    return accountNo.includes('/')
      ? accountNo.split('/').pop()?.trim()
      : accountNo;
  };

  // Get account display name (from nested object or cache)
  const getSubAccountName = (item) => {
    if (item?.account?.name_ar || item?.account?.name_en) {
      return currentLangId === "en" ? item?.account?.name_en : item?.account?.name_ar;
    }
    if (item?.account_no) return getAccountName(item?.account_no);
    return "";
  };

  const addAccount = () => {
    let errors = {};

    if (!AccountCode) errors.code = "Code Is Required";
    if (!bank_account_iban)
      errors.bank_account_iban = "bank_account_iban Is Required";
    if (!AccountName) errors.name_ar = "Arabic Name Is Required";

    if (Object.keys(errors).length > 0) {
      if (errors.name_ar) setLangar(true);
      setError(errors);
      return;
    }

    const AccountData = {
      code: AccountCode,
      name_ar: AccountName || "-",
      name_en: AccountEnName || "-",
      account_no: subAccount,
      bank_account_no: bank_account_no,
      bank_account_iban: bank_account_iban,
      tenant_id: currentTenantId,
      company_id: currentCompanyId,
      branch_id: currentBranchId,
    };

    const resetForm = () => {
      setAccountCode("");
      setAccountName("");
      setAccountEnName("");
      setbank_account_ibana("");
      setbank_account_no("");
      setSubAccount("");
      setIsEditing(false);
      setEditingAccountId(null);
      setError({});
    };

    if (!isEditing) {
      postData(
        `${process.env.REACT_APP_FINANCE_API_SERVER_BASE_URL}/banks-accounts`,
        AccountData
      ).then(() => {
        refetchTreasuries();
        refreshHandler();
        resetForm();
      });
    } else {
      putData(
        `${process.env.REACT_APP_FINANCE_API_SERVER_BASE_URL}/banks-accounts/${editingAccountId}`,
        AccountData,
        "settings"
      ).then(() => {
        refetchTreasuries();
        refreshHandler();
        resetForm();
      });
    }
  };

  const deleteAccount = (id) => {
    deleteItem(
      `${process.env.REACT_APP_FINANCE_API_SERVER_BASE_URL}/banks-accounts/${id}`
    ).then(() => {
      refetchTreasuries();
      refreshHandler();
      setOnShow(false);
    });
  };

  return (
    <>
      {!AccountCode ? (
        <div className="h-20 w-full justify-center items-center flex-wrap flex">
          <MwSpinnerButton />
        </div>
      ) : (
        <section className="flex flex-col flex-1">
          <ConfirmDelete
            onShow={onShow}
            setOnShow={setOnShow}
            onDeleteHandler={() => deleteAccount(selectedAccountId)}
            loading={delloading}
            msg={t("account.accountydel")}
          />
          <div className="flex justify-end mb-3">
            <NewButton onClick={addAccount}>
              {loading || saveloading ? (
                <MwSpinnerButton />
              ) : isEditing ? (
                t("general.update")
              ) : (
                <>
                  <IoMdAdd className="text-white text-lg group-hover:text-[#fffff]" />
                  <p className="">{t("general.Add")}</p>
                </>
              )}
            </NewButton>
          </div>
          <div className="flex justify-start  flex-wrap w-full items-end gap-2">
            <div className="w-24">
              <MwInputText
                invalid={error?.code}
                disabled={true}
                label={t("account.accountcode")}
                value={AccountCode}
                onChange={(e) => setAccountCode(e.target.value)}
                classNameInput="w-[100%] text-center  flex-1  "
              />
            </div>
            <div className="w-48">
              <MwInputText
                invalid={error?.bank_account_no}
                disabled={false}
                label={t("account.accountno")}
                placeholder={t("account.accountnoplace")}
                value={bank_account_no}
                onChange={(e) => setbank_account_no(e.target.value)}
                classNameInput="w-[100%]  flex-1  "
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/\D/g, "");
                }}
              />
            </div>
            <div className="w-48">
              <MwInputText
                invalid={error?.bank_account_iban}
                disabled={false}
                label={t("account.ibanaccount")}
                placeholder={t("account.ibanaccountplace")}
                value={bank_account_iban}
                onChange={(e) => setbank_account_ibana(e.target.value)}
                classNameInput="w-[100%]  flex-1  "
                onInput={(e) => {
                  e.target.value = e.target.value
                    .replace(/[^0-9a-zA-Z]/g, "")
                    .toUpperCase();
                }}
              />
            </div>
            <div className="w-48 flex flex-col justify-center">
              <NewInputLang
                invalid={error?.name_ar || error?.name_en}
                placeholder={t("account.accountnameplaceholder")}
                label={t("account.accountname")}
                value={langar ? AccountName : AccountEnName}
                langar={langar}
                onChange={(value) => {
                  if (langar) {
                    setAccountName(value);
                  } else {
                    setAccountEnName(value);
                  }
                }}
                onChangeLang={() => setLangar(!langar)}
                classNameInput="w-[100%] flex-1"
              />
            </div>
            <div className="flex-1 min-w-64">
              <MwSelectorAccount
                key={isEditing ? `account-edit-${editingAccountId || "none"}-${subAccount || "empty"}` : "account-create"}
                withLabel={true}
                placeholder={t("account.accountAccount")}
                classNamePrivate="flex-1 w-full"
                invalid={error?.account}
                initialValue={`${subAccount || ""}`}
                onChangeCallback={(selectedAccount) => {
                  setSubAccount(selectedAccount?.account_no || "");
                }}
                levelLimit={chartLevelLimit}
              />
            </div>
          </div>

          {loadingTreasuries && AccountList?.length === 0 ? (
            <div className="h-40 flex justify-center items-center w-full">
              {" "}
              <MwSpinnerButton />
            </div>
          ) : AccountList?.length > 0 ? (
            <>
              <>
                <div className="flex w-full mt-3 justify-around bg-[#F2F0FC] p-3 rounded-t-lg font-[800] text-[#251658] text-sm">
                  <div className="w-32 text-center">
                    {t("account.accountcode")}
                  </div>
                  <div className="w-40 text-center">
                    {t("account.accountno")}
                  </div>
                  <div className="w-40 text-center">
                    {t("account.ibanaccount")}
                  </div>
                  <div className="w-40 text-center">
                    {t("account.accountname")}
                  </div>
                  <div className="w-48 text-center">
                    {t("account.accountaccountshow")}
                  </div>
                  <div className="w-20 text-center"></div>
                </div>
                <div className="divide-y  ">
                  {AccountList.map((item, index) => (
                    <div
                      key={index}
                      className="flex w-full border-b border-[#ddd0bf] border-opacity-25 cursor-pointer justify-around items-center p-3 text-[#251658] font-semibold text-sm"
                    >
                      <div className="w-32 text-center">{item?.code}</div>
                      <div className="w-40 text-center">
                        {item?.bank_account_no}
                      </div>
                      <div className="w-40 text-center">
                        {item?.bank_account_iban}
                      </div>
                      <div className="w-40 text-center">
                        {currentLangId === "ar" ? item?.name_ar : item?.name_en}
                      </div>
                      <div className="w-48 text-center">
                        {!isCacheReady && (item?.account_no || item?.account?.account_no) ? (
                          <div className="flex items-center justify-center gap-1">
                            <div className="h-3 w-10 bg-gray-200 rounded animate-pulse" />
                            <div className="h-3 w-20 bg-gray-200 rounded animate-pulse" />
                          </div>
                        ) : (
                          (() => {
                            const no = getExtractedAccountNo(item);
                            const name = getSubAccountName(item);
                            if (!no && !name) return <span className="text-gray-400">—</span>;
                            return (
                              <div className="flex items-center justify-center gap-1">
                                {no && (
                                  <span className="text-xs text-gray-500 font-semibold bg-gray-100 px-1.5 py-0.5 rounded">
                                    {no}
                                  </span>
                                )}
                                {no && name && <span className="text-gray-300 text-xs">|</span>}
                                {name && (
                                  <span className="font-semibold text-[#251658] text-xs">
                                    {name}
                                  </span>
                                )}
                              </div>
                            );
                          })()
                        )}
                      </div>
                      <div className="w-20 flex justify-center items-center gap-2">
                        <button
                          onClick={() => {
                            setIsEditing(true);
                            setEditingAccountId(item.id);
                            setAccountCode(item.code);
                            setAccountName(item.name_ar);
                            setAccountEnName(item.name_en);
                            setbank_account_ibana(item.bank_account_iban);
                            setbank_account_no(item.bank_account_no);
                            // Extract just the account number from the existing data
                            const accountNo = item?.account_no || item?.account?.account_no || "";
                            // If it's in the old format "Name/Number", extract the number
                            const extractedAccountNo = accountNo.includes('/') 
                              ? accountNo.split('/').pop()?.trim() 
                              : accountNo;
                            setSubAccount(extractedAccountNo);
                          }}
                          className="text-blue-500 hover:text-blue-700 mx-2"
                        >
                          <img
                            className="w-4"
                            src="/assets/icons/Edit.png"
                            alt="delete"
                            srcSet=""
                          />
                        </button>
                        <button
                          onClick={() => {
                            setSelectedAccountId(item.id);
                            setOnShow(true);
                          }}
                          className="text-red-500 hover:text-red-700"
                        >
                          <img
                            className="w-4"
                            src="/assets/icons/Trash.png"
                            alt="delete"
                            srcSet=""
                          />
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            </>
          ) : (
              <div className=" h-[calc(100vh-230px)] ">
                        <SettingsEmptyState msg={t("account.validate")} />
                        </div> 
          )}
        </section>
      )}
    </>
  );
};
